import { mergeObjects } from 'corporate-utils';
import common from './default';

const override = {};

export const sirman = mergeObjects(common, override);
